import translate from '@src/services/translate'
import { FieldError as Error } from 'react-hook-form'

export default function translateErrorCode(err?: Error) {
  if (!err) return ''
  return err.message ? translate(err.message) : ''
}
